import { render, staticRenderFns } from "./maintenance-icon.vue?vue&type=template&id=1bd0fae2&"
import script from "./maintenance-icon.vue?vue&type=script&lang=js&"
export * from "./maintenance-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports